import getDashboardUserPermissions from '@/utils/getDashboardUserPermissions';
import {PermissionObject, RequestedPermission} from '@/types/permissions';
import useDashboardUserQuery from '@/hooks/queries/use-dashboard-user-query';

export type {RequestedPermission} from '@/types/permissions';

function useDashboardUserPermissions(
  requestedPermissions: RequestedPermission[],
  dashboardUserPermissions?: PermissionObject[]
) {
  const {data: dashboardUserData}: any = useDashboardUserQuery({
    enabled: !!dashboardUserPermissions,
  });

  const permissions =
    dashboardUserPermissions ?? dashboardUserData?.permissions;
  return getDashboardUserPermissions(requestedPermissions, permissions);
}

export default useDashboardUserPermissions;
